import { Modal, Form, Input, Select, Tag } from 'antd';
import { authFetch } from '../../../../../common/request/authFetch';
import { useTranslation } from 'react-i18next';
import { ENDPOINTS } from '../../../menuUsers/api/API';

export const AddApiModal = (props : {project: any, onFinish: any}) => {
    
    const [form] = Form.useForm();
    
	const { t } = useTranslation();    
    
    const onFormFinish = async (values: any) => {
        const data = {
            ...values
        };
        await authFetch(`${process.env.REACT_APP_API}/projects/${props.project.name}/endpoints`, { method: 'PUT', data: data });        
        props.onFinish();
    };

  return (
    <>
        <Modal 
            open={true} 
            onOk={() => form.submit()} 
            onCancel={props.onFinish} 
            afterClose={form.resetFields}>
            <h2>Endpoints</h2>

            <Form 
                layout='vertical' 
                form={form} 
                onFinish={onFormFinish}
                autoComplete="off">
                <Form.Item 
                    initialValue={props.project.name}
                    label='Nombre' 
                    name='name' >
                    <Input disabled={true} className="disabled" />
                </Form.Item>                
                <Form.Item label='Endpoint' name='endpoints'>
					<Select mode="multiple" defaultValue={props.project.endpoints}>
                        {Object.keys(ENDPOINTS).map((key: string) => (
                                <Select.Option value={key}>
                                    {key}
                                </Select.Option>
                            )
                        )}	
					</Select>
				</Form.Item>	
            </Form>
        </Modal>
    </>
  )
}

